import React, { useContext } from "react";

import MembershipFormContext from '../../context/membership'
import { getSS } from '../../helpers'
interface StepIndicatorProps {
  [key: string]: any
}

const StepIndicator: React.FC<StepIndicatorProps> = (props: any) => {

  const membershipForm = useContext(MembershipFormContext)
  const membership_form = (window as any).KEW.collections.membership_form[0]
  const wakehurstMembership = getSS('membership')?.selected_membership?.wakehurst_membership
  const formTitle = wakehurstMembership ? 'Become a Wakehurst member' : 'Become a member of Kew'
  const orgName = wakehurstMembership ? 'Wakehurst' : 'Kew'

  return (
    <>
      <div className="row">
        <div className="step-indicator clearfix box">
          <div className="large-12 columns">
            { membership_form.form_type !== 'renewal' && membership_form.form_type !== 'upgrade' &&
              <h1>{formTitle}</h1>
            }
            { membership_form.form_type === 'renewal' &&
              <h1>Renew your {orgName} Membership</h1>
            }
            { membership_form.form_type === 'upgrade' &&
              <h1>Upgrade your Membership</h1>
            }
            { !membershipForm.preSelectedMembership &&
              <div className="steps">
                <div className={`step done${membershipForm.currentStep === 1 ? ' active' : ''}`}>
                  <div className="label-wrapper">
                    <label>1. Done</label>
                  </div>
                  <div className="stripe"></div>
                  <div className="copy">
                    <div className="desktop">Your membership</div>
                    <div className="mobile">Membership</div>
                  </div>
                </div>
                <div className={`step${membershipForm.currentStep === 2 ? ' active' : ''}${membershipForm.currentStep > 2 ? ' done' : ''}`}>
                  <div className="label-wrapper">
                    <label>{membershipForm.currentStep > 2 ? '2 done' : '2'}</label>
                  </div>
                  <div className="stripe"></div>
                  <div className="copy">
                    <div className="desktop">Your details</div>
                    <div className="mobile">Details</div>
                  </div>
                </div>
                <div className={`step${membershipForm.currentStep === 3 ? ' active' : ''}${membershipForm.currentStep > 3 ? ' done' : ''}`}>
                  <div className="label-wrapper">
                    <label>{membershipForm.currentStep > 3 ? '3 done' : '3'}</label>
                  </div>
                  <div className="stripe"></div>
                  <div className="copy">
                    <div className="desktop">Review your membership</div>
                    <div className="mobile">Review</div>
                  </div>
                </div>
                <div className={`step ${membershipForm.currentStep === 4 ? ' active' : ''}`}>
                  <div className="label-wrapper">
                    <label>4</label>
                  </div>
                  <div className="stripe"></div>
                  <div className="copy">
                    <div className="desktop">Payment details</div>
                    <div className="mobile">Payment</div>
                  </div>
                </div>
              </div>
            }
            { membershipForm.preSelectedMembership &&
              <div className="steps">
                <div className={`step third${membershipForm.currentStep === 1 ? ' active' : ''}${membershipForm.currentStep > 1 ? ' done' : ''}`}>
                  <div className="label-wrapper">
                    <label>1</label>
                  </div>
                  <div className="stripe"></div>
                  <div className="copy">
                    <div className="desktop">Your details</div>
                    <div className="mobile">Details</div>
                  </div>
                </div>
                <div className={`step third${membershipForm.currentStep === 2 ? ' active' : ''}${membershipForm.currentStep > 2 ? ' done' : ''}`}>
                  <div className="label-wrapper">
                    <label>2</label>
                  </div>
                  <div className="stripe"></div>
                  <div className="copy">
                    <div className="desktop">Review your membership</div>
                    <div className="mobile">Review</div>
                  </div>
                </div>
                <div className={`step third${membershipForm.currentStep === 3 ? ' active' : ''}${membershipForm.currentStep > 3 ? ' done' : ''}`}>
                  <div className="label-wrapper">
                    <label>3</label>
                  </div>
                  <div className="stripe"></div>
                  <div className="copy">
                    <div className="desktop">Payment details</div>
                    <div className="mobile">Payment</div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default StepIndicator;